import React from 'react'
import MobileDatePickerControlBar from './MobileDatePickerControlBar.jsx'

import './CalendarPopup.scss'

// This is the CONTAINER for the react DatePicker component.

const CalendarPopup = ({
  calendarTitleText,
  children,
  additionalClassNames = '',
  mobileLmpDate,
  mobileProps,
}) => {
  return (
    <div className={`CalendarPopup ${additionalClassNames}`}>
      <div className="calendar-header">
        <h2>{calendarTitleText}</h2>
        {mobileProps && (
          <MobileDatePickerControlBar
            mobileLmpDate={mobileLmpDate}
            onClear={mobileProps.onClear}
            selectText={mobileProps.selectText}
            clearText={mobileProps.clearText}
          />
        )}
      </div>

      <div className="calendar">{children}</div>
    </div>
  )
}

export default CalendarPopup
